export const fruitSoup = {
  id: "fruitSoup",
  link: "/#/recipes/recipes/fruitSoup",
  name: "Fruit Soup",
  cuisine: "Kharbranthian",
  summary: "A cold juice-based broth with fresh fruits",
  inspiration: null,
  quantity: "4 servings",
  time: "15 minutes preparation, 3 hours chilling",
  notes:
    "Fruit soup is one of the stranger things I decided to make from the books. I decided to go for a cold soup - really more of a fruit salad with juice. I picked fruits that I could trace back to the books, and I'm happy with how it came out.",
  quotes:
    "...a clear, cold stew with sweet vegetables for the women (The Way of Kings ch 29)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/fruit-soup-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "ginger",
          display: "1 inch ginger root"
        },
        {
          item: "cinnamon",
          display: "1 small stick cinnamon"
        },
        {
          item: "aniseSeed",
          display: "1/2 tsp anise seeds"
        },
        {
          item: "cloves",
          display: "4 cloves"
        },
        {
          item: "nuts",
          display: "1/8 tsp almond extract"
        },
        {
          item: "passionfruit",
          display:
            "2 cups passionfruit juice (juice blends and flavored juice drinks are fine. Just pick something you would drink.)"
        },
        {
          item: "plum",
          display: "1 plum"
        },
        {
          item: "cucumber",
          display: "1/2 cucumber"
        },
        {
          item: "kiwi",
          display: "2 kiwifruit"
        },
        {
          item: "avocado",
          display: "1 avocado"
        },
        {
          item: "sugar",
          display: "2 tsp granulated sugar"
        }
      ]
    }
  ],
  steps: [
    "Peel the ginger and cut into medium sized chunks. Break the cinnamon stick into small pieces. In a saucepan, combine the cinnamon, anise seeds, cloves, ginger, almond extract, and passionfruit juice. Bring to a boil over medium-high heat, then remove from heat, cover, and let sit 1 hour.",
    "Strain out the solids and discard. Chill the liquid in the refrigerator until cold, about 2 hours.",
    "Chop the fruits and vegetables to 1/2-3/4 inch cubes: chop the plum, then peel and chop the cucumber, kiwis, and avocado. Toss together with the sugar.",
    "To serve, put some of the fruit mixture in a bowl, then pour the chilled juice over, just enough to not quite cover the fruit."
  ]
}
